(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wd-support-center"] && !Shopify.designMode) return;
  try {
    

(() => {
 const initialize = (root) => {
  if (root.dataset.supportInitialized) return;
  root.dataset.supportInitialized = 'true';
  const form = root.querySelector('[data-support-form]');
  form.querySelector('[type=submit]').disabled = false;
  const select = root.querySelector('[data-support-select]');
  const topics = root.querySelectorAll('[data-support-topic]');
  const sync = () => topics.forEach(button => button.setAttribute('aria-pressed', String(select.selectedOptions[0]?.dataset.topicKey === button.dataset.supportTopic)));
  topics.forEach(button => button.addEventListener('click', () => {
   const option = Array.from(select.options).find(item => item.dataset.topicKey === button.dataset.supportTopic);
   if (option) select.value = option.value;
   sync();
   root.querySelector('.wd-support__form').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
   select.focus({preventScroll:true});
  }));
  select.addEventListener('change',sync);
  const dialog = root.querySelector('[data-support-dialog]');
  root.querySelector('[data-support-close]').addEventListener('click', () => dialog.close());
  const allowed = new Set(['jpg','jpeg','png','webp','gif','heic','mp4','mov','webm']);
  const picker = form.querySelector('[data-support-files]');
  const fileSummary = form.querySelector('[data-support-file-summary]');
  const syncFiles = () => {
   const names = Array.from(picker.files, file => file.name).join(', ');
   fileSummary.textContent = names || fileSummary.dataset.emptyLabel;
   fileSummary.title = names;
  };
  const status = form.querySelector('[data-support-status]');
  const error = form.querySelector('[data-support-error]');
  const validFiles = () => {
   const files = Array.from(picker.files);
   return files.length <= 3 && files.reduce((n,f) => n+f.size,0) <= 50*1024*1024 && files.every(f => f.size > 0 && f.size <= 20*1024*1024 && allowed.has(f.name.split('.').pop().toLowerCase()));
  };
  picker.addEventListener('change', () => {
   syncFiles();
   const valid = validFiles();
   picker.setCustomValidity(valid?'':root.dataset.fileError);
   error.hidden = valid;
   if (!valid) error.textContent = root.dataset.fileError;
  });
  let requestId = null, session = null, slots = null, requestSignature = null;
  const jsonRequest = async (url, options) => {
   const response = await fetch(url, {credentials:'omit',signal:AbortSignal.timeout(30000),...options});
   if (!response.ok) throw new Error('Request failed');
   return response.json();
  };
  form.addEventListener('submit', async (event) => {
   event.preventDefault();
   if (!form.reportValidity() || !validFiles()) return;
   if (root.dataset.formMode === 'preview') { dialog.showModal(); return; }
   const files = Array.from(picker.files), data = new FormData(form);
   const message = {email:data.get('contact[email]'),order_number:data.get('contact[Order number]')||'',topic:select.selectedOptions[0].dataset.topicKey,message:data.get('contact[body]'),source:'Watchdives Support Center'};
   const signature = JSON.stringify({message,files:files.map(f=>[f.name,f.size,f.lastModified])});
   if (signature !== requestSignature) { requestId = crypto.randomUUID(); session = null; slots = null; requestSignature = signature; }
   const controls = [...form.querySelectorAll('input,select,textarea,button'),...topics];
   controls.forEach(control => control.disabled = true);
   error.hidden = true; status.hidden = false; status.classList.remove('wd-support__success'); status.textContent = root.dataset.uploadStatus;
   try {
    const base = new URL(form.dataset.receiverBase);
    if (base.origin !== 'https://ai.chemeri.com' || base.search || base.hash || base.pathname.replace(/\/$/,'') !== '/api/storefront-support/watchdives') throw new Error('Invalid receiver');
    const receiver = base.origin+base.pathname.replace(/\/$/,'');
    session ||= await jsonRequest(receiver+'/session', {cache:'no-store'});
    if (!session.session_token) throw new Error('Invalid session');
    const headers = {'Content-Type':'application/json'};
    slots ||= files.length ? await jsonRequest(receiver+'/uploads', {method:'POST',headers,body:JSON.stringify({session_token:session.session_token,request_id:requestId,files:files.map(f=>({filename:f.name,content_type:f.type,size:f.size}))})}) : {uploads:[]};
    if (!Array.isArray(slots.uploads) || slots.uploads.length !== files.length) throw new Error('Invalid uploads');
    for (let i=0;i<files.length;i++) {
     const slot = slots.uploads[i], upload = new URL(slot.url);
     if (upload.protocol !== 'https:' || slot.method !== 'PUT' || !slot.upload_id || !Array.isArray(session.upload_hosts) || !session.upload_hosts.includes(upload.hostname)) throw new Error('Invalid upload destination');
     const sent = await fetch(upload.href, {method:'PUT',body:files[i],headers:slot.headers||{},credentials:'omit',signal:AbortSignal.timeout(120000)});
     if (!sent.ok) throw new Error('Upload failed');
    }
    const receipt = await jsonRequest(receiver+'/requests', {method:'POST',headers,signal:AbortSignal.timeout(90000),body:JSON.stringify({...message,session_token:session.session_token,request_id:requestId,upload_ids:slots.uploads.map(u=>u.upload_id)})});
    if (receipt.status !== 'received' || typeof receipt.reference !== 'string' || !/^[A-Za-z0-9-]{1,80}$/.test(receipt.reference)) throw new Error('Unconfirmed receipt');
    status.textContent = root.dataset.submitSuccess+' '+receipt.reference;
    status.classList.add('wd-support__success');
    form.reset(); picker.setCustomValidity(''); syncFiles(); sync(); requestId=null; session=null; slots=null; requestSignature=null;
   } catch (err) {
    error.textContent = root.dataset.submitError; error.hidden = false; status.textContent = ''; status.hidden = true;
   } finally { controls.forEach(control => control.disabled = false); }
  });
 };
 const initAll = parent => parent.querySelectorAll('[data-support-root]').forEach(initialize);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true});
 else initAll(document);
 document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
